module.exports = __webpack_public_path__ + "static/media/gate_logo.4ba83a52.png";